<template>
    <div v-loading="pageLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="path" label="启动图:">
                        <image-upload :url.sync="formData.path" :urlFull.sync="formData.path" :width="1242"
                            :height="2208"></image-upload>
                    </el-form-item>
                    <el-form-item prop="isShow" label="状态:">
                        <el-radio-group v-model="formData.isShow">
                            <el-radio :label="1">展示</el-radio>
                            <el-radio :label="2">隐藏</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="rate" label="展示权重:">
                        <el-radio v-model="formData.rate" :label="5">较低</el-radio>
                        <el-radio v-model="formData.rate" :label="20">普通</el-radio>
                        <el-radio v-model="formData.rate" :label="100">较高</el-radio>
                    </el-form-item>
                    <el-form-item v-if="id" prop="isBatchUpdate">
                        <span slot="label">
                            批量更新：
                            <el-checkbox v-model="formData.isBatchUpdate" :true-label="1" :false-label="0"
                                @change="batchUpdateFlagChange">开启批量更新</el-checkbox>
                        </span>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="名称:">
                        <el-input placeholder="请填写名称" v-model="formData.title" maxlength="40" size="medium"></el-input>
                    </el-form-item>
                    <el-form-item prop="time1" label="展示时间段1:">
                        <el-date-picker v-model="formData.time1" type="datetimerange" range-separator="至"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                            start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
                        </el-date-picker>                       
                    </el-form-item>
					<el-form-item prop="time2" label="展示时间段2:">
					    <el-date-picker v-model="formData.time2" type="datetimerange" range-separator="至"
					        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
					        start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
					    </el-date-picker>					    
					</el-form-item>
					<el-form-item prop="time3" label="展示时间段3:">
					    <el-date-picker v-model="formData.time3" type="datetimerange" range-separator="至"
					        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
					        start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
					    </el-date-picker>
					    <small>
					        <span class="el-icon-warning"></span>
					        最晚的展示时间段到期后，启动图会被自动隐藏<br />
					    </small>
					</el-form-item>
					<el-form-item prop="jumpValue" label="跳转目标:">
                        <el-input v-model="formData.jumpValue" :maxlength="formData.jumpType === 3 ? 200 : 10"
                            class="input-with-select" @input="onInput"
                            :placeholder="formData.jumpType === 3 ? '请填写链接' : formData.jumpType === 4 ? '请填写立减活动ID'  : formData.jumpType === 1 ? '请填写演出ID' : '请填写巡演ID'"
                            size="medium">
                            <el-select v-model="formData.jumpType" slot="prepend" placeholder="请选择">
                                <el-option label="演出" :value="1"></el-option>
                                <el-option label="巡演" :value="2"></el-option>
								<el-option label="立减活动" :value="4"></el-option>
                                <el-option label="普通链接" :value="3"></el-option>
                            </el-select>
                            <el-button slot="append" :loading="jumpLoading" @click="verifyJump">跳转解析</el-button>
                        </el-input>
                        <el-alert v-if="jumpText" :title="jumpText" type="info" show-icon :closable="false"></el-alert>
                    </el-form-item>
                    <el-form-item v-if="formData.jumpType === 2" prop="tourJumpRule" label="巡演跳转规则:">
                        <el-radio v-model="formData.tourJumpRule" :label="1">巡演所含城市的启动图跳转至各自演出详情页，其余城市的启动图跳转至巡演列表页
                        </el-radio>
                        <el-radio v-model="formData.tourJumpRule" :label="2">所有城市的启动图统一跳转至巡演列表页</el-radio>
                    </el-form-item>
                    
                   <!-- <el-form-item prop="cityCodes" label="展示城市:">
                        <div class="form-flex">
                            <city-select :value.sync="formData.cityCodes" :value-options="cityOptions" multiple>
                            </city-select>
                        </div>
                        <small class="MT10">
                            <span class="el-icon-warning"></span>
                            如果需要全国展示,请选择【全国】,
                            如果填写了多个展示城市,系统会为每个城市创建单独的启动图
                        </small>
                    </el-form-item> -->
					<el-form-item prop="city" v-if="!formData.id">								
						<el-form-item prop="settingType" >
							<span slot="label"><span class="color-danger">*</span> 展示城市:</span>
							<el-radio-group v-model="formData.settingType">
								<el-radio :label="0">全国展示</el-radio>
								<el-radio :label="1">只在下面地区展示</el-radio>
								<!-- <el-radio :label="2"><span style="color:#F56C6C">不在</span>下面地区展示</el-radio> -->
							</el-radio-group>
						</el-form-item>
						<el-form-item prop="sellArea" v-if="formData.settingType != 0">
							<span slot="label">地区设置:</span>
							<el-cascader v-model="sellArea" :options="cityList" filterable
								:props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
								style="width:100%" ref="cityCascader">
							</el-cascader>
							<small class="MT10 red">							   
								如果指定了多个城市，系统会为每个城市创建单独的Banner<br>如果同时设置了省份和省份下的某个城市展示，则全省展示<br>如果同时设置了省份和省份下的某个城市不展示，则全省不展示
							</small>
						</el-form-item>						
					</el-form-item>
					<el-form-item prop="city" v-else>						
						<span slot="label"><span class="color-danger">*</span> 展示城市:</span>
						<city-select :value.sync="formData.city" :value-options="cityOptions" :multiple="!id"></city-select>
						<small class="MT10 red">
							<span class="el-icon-warning"></span> 如果需要全国展示，请填写【全国】
						</small>						
					</el-form-item>
                </el-col>
            </el-row>
            <BatchUpdate v-if="formData.isBatchUpdate === 1" :formData.sync="formData" :queryValue="title"></BatchUpdate>
            <el-form-item>
                <el-button @click="goBack()">返回</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
                <el-button v-if="this.id" type="danger" @click="del">删除</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import CitySelect from '@/components/CitySelect';
import BatchUpdate from './components/batchUpdate';
import { fetchAllCity } from '@/assets/js/commonApi'
const JUMP_TEXT = [
    '将会跳转至演出详情页，展示城市已自动填写完成',
    '请进一步设置巡演跳转规则，展示城市已自动填写完成',
    '将会跳转至对应链接，请填写展示城市'
];
export default {
    components: { ImageUpload, CitySelect, BatchUpdate },
    data() {
        return {
            id: this.$route.params.id,
            formData: {
                jumpType: 1,
                cityCodes: [],
                tourJumpRule: 1,
                time1: [], //展示时间段1
				time2: [],
				time3: [],
                rate: 20,
                title: '',
                path: '',
                isShow: 1,
                contents: [],
                ids: [],
                isBatchUpdate: 0,
				settingType:0
            },
            rules: {
                title: [{ required: true, message: "请填写名称" }],
                jumpValue: [{ required: true, message: "请填写跳转目标，并进行解析" }],
                cityCodes: [{ required: true, message: "请选择城市" }],
                isShow: [{ required: true, message: "请选择状态" }],
                path: [{ required: true, message: "请设置启动图片" }],
                rate: [{ required: true, message: "请选择展示权重" }],
            },
            cityAll: false,
            cityOptions: [],
            jumpText: '',
            jumpLoading: false,
            btnLoading: false,
            pageLoading: false,
            verifyJumpNum: '',

            redirect: this.$route.query.redirect || '',
            title: "",
			cityList: [],
			sellArea:[]
        };
    },
    mounted() {
        if (this.id) this.getDetail();
    },
	async created() {
		await this.getCityList();		
	},
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
		//获取城市列表
		async getCityList() {
			const res = await fetchAllCity({}).catch(() => { });
			const { state, result } = res.data;
			if (state == 1) {
				this.cityList = result;
			}
		},
        //  验证跳转值
        async verifyJump() {
            if (!this.formData.jumpValue) return this.$message.error('请填写需要验证的内容');
            if (this.formData.jumpType === 3) return this.jumpText = JUMP_TEXT[this.formData.jumpType - 1];
            this.jumpLoading = true;
            this.jumpText = '';
            const response = await this.$request({
                url: "/diagram/check",
                method: "POST",
                data: { type: this.formData.jumpType, value: this.formData.jumpValue },
            });
            const { state, msg, result } = response.data;
            this.jumpLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.jumpText = JUMP_TEXT[this.formData.jumpType - 1];
            this.verifyJumpNum = this.formData.jumpValue;
            if (result && result.length > 0) {
				this.sellArea = []
				if( this.formData.jumpType == 2 ){							
					const cityCodesxy = [];
				    result.forEach(function (item, index) {				       
				        cityCodesxy.push([item.provinceCode, item.cityCode]);
				    })
					this.sellArea = cityCodesxy;
				}					
               			
                this.cityOptions = result.map(city => {
					if( this.formData.jumpType == 1 ){
						 const cityCodes = [];	
						cityCodes.push(city.provinceCode,city.cityCode);
						this.formData.cityCodes = cityCodes;
						var citycodes2 = []
							citycodes2.push(cityCodes)
							this.sellArea = citycodes2;
					}					
                    return { value: city.cityCode, label: city.cityName }
                });
					console.log( this.sellArea)
					this.formData.settingType = 1
            }
        },
        // 获取详情
        async getDetail() {
            this.pageLoading = true;
            const response = await this.$request({
                url: "/diagram/info",
                method: "POST",
                params: { id: this.id },
            });
            const { msg, state, result } = response.data;
            this.pageLoading = false;

            if (state != 1) return this.$message.error(msg);
            // if (result.codeAndNameVo) {
            //     if (result.codeAndNameVo.cityCode != 0) {
            //         result.cityCodes = [result.codeAndNameVo.cityCode];
            //         this.cityOptions = [{ value: result.codeAndNameVo.cityCode, label: result.codeAndNameVo.cityName }];
            //     } else {
            //         result.cityCodes = ['0'];
            //         this.cityAll = true;
            //     }
            // }
			if (result.cityCode && result.cityCode != 0) {
				result.city = result.cityCode.toString();
				this.cityOptions = [{ value: result.cityCode.toString(), label: result.cityName }];
			} else {
				result.city = '0';
			}
            if (result.firstStartDate && result.firstEndDate) result.time1 = [result.firstStartDate, result.firstEndDate];
			if (result.secondStartDate && result.secondEndDate) result.time2 = [result.secondStartDate, result.secondEndDate];
			if (result.startDate && result.autoDeleteTime) result.time3 = [result.startDate, result.autoDeleteTime];
			
			
			
            delete result.codeAndNameVo
            this.verifyJumpNum = result.jumpValue;
            this.formData = { ...this.formData, ...result };

            this.title = result.title;
        },
        //表单提交
        onSubmit() {
            if (this.verifyJumpNum !== this.formData.jumpValue && this.formData.jumpType !== 3) return this.$message.error('请先解析跳转目标');
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const form = JSON.parse(JSON.stringify(this.formData));
                    if (form.time3 && form.time3.length === 2) {
                        form.startDate = form.time3[0];
                        form.autoDeleteTime = form.time3[1];
                    } else {
                        form.startDate = '';
                        form.autoDeleteTime = '';
                    }
					if (form.time1 && form.time1.length === 2) {
					    form.firstStartDate = form.time1[0];
					    form.firstEndDate = form.time1[1];
					} else {
					    form.firstStartDate = '';
					    form.firstEndDate = '';
					}
					if (form.time2 && form.time2.length === 2) {
					    form.secondStartDate = form.time2[0];
					    form.secondEndDate = form.time2[1];
					} else {
					    form.secondStartDate = '';
					    form.secondEndDate = '';
					}
					
					
                    //form.cityCodes = form.cityCodes.toString();

                    if(form.id){
                        form.batchUpdateTO = {
                            contents: form.contents || [],
                            id: form.id || "",
                            ids: form.ids
                        }
                    }
					
					if(!form.id){
						form.province = [];
						form.city = [];
						this.sellArea.map(item => {
							if (!form.province.find(v => v == item[0]) && !item[1]) {
								form.province.push(item[0]);
							}
							item[1] && form.city.push(item[1]);
						})
					}else{
						const city = JSON.parse(form.city)
						form.city=[]
						form.city.push(city)
						//form.city = form.city.toString()
					}
					
                    const response = await this.$request({
                        url: "/diagram/save",
                        method: "POST",
                        data: form,
                    });
                    const { msg, state } = response.data;
                    this.btnLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('启动页保存成功');
                    this.goBack();
                }
            });
        },
        onInput(value) {
            if (this.formData.jumpType === 3) return;
            if (!/^[0-9]+$/.test(value)) this.formData.jumpValue = '';
        },
        //删除演出
        del() {
            const _msg = '确认删除该启动图?';
            this.$confirm(_msg, '删除启动图', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/diagram/delete",
                    method: "POST",
                    params: { id: this.id },
                });
                const { msg, state } = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('启动页删除成功');
                this.goBack()
            })
        },
        batchUpdateFlagChange(e) {
            if (e === 0) {
                this.formData.ids = [];
                this.formData.contents = [];
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.form-flex {
    display: flex;

    .el-checkbox {
        margin-left: 10px;
    }
}

.el-alert {
    padding: 0px 16px;
}
.red{
		color:#F56C6C
	}
</style>